import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CheckLoggedIn = ({ children, admin = false }) => {
  const userLoggedIn = useSelector(state => state.userLoggedIn)



  const navigate = useNavigate();
  useEffect(() => {
    if (!userLoggedIn.loggedIn) {
      navigate('/login');
    }
    else if (admin && !userLoggedIn.admin) {
      navigate('/')
    }
  }, [userLoggedIn]);

  return userLoggedIn && userLoggedIn.loggedIn ? <>{children}</> : null
}

export default CheckLoggedIn;
